import React, { useState } from "react";

//Images

import forgotImage from "../../assets/images/forgot.svg";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import AuthService from "../../services/AuthService";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import lockImage from "../../assets/images/lock.svg";
import LogoImg from "../../assets/images/Main-Logo.png";
import HelmetBase from "../../components/HelmetBase";

const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const ForgotPassword = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const { systemConfiguration } = useSelector((state) => state.commonStore);

  const [loading, setLoading] = useState(false);

  const formValidations = Yup.object({
    email: Yup.string()
      .trim()
      .test(
        "email",
        t("Please enter a valid email or Phone number"),
        (value) => {
          return emailRegex.test(value) || phoneRegExp.test(value);
        }
      )
      .required(t("Email or Phone Number is Required")),
  });

  const dispatch = useDispatch();

  // let websiteURL = process.env.REACT_APP_URL;

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: formValidations,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      setLoading(true);
      AuthService.forgotPassword(values)
        .then((res) => {
          if (res.status == 1) {
            resetForm();
            navigate(`/otp?email=${values.email}`);
          } else {
            setLoading(false);
            setSubmitting(false);
          }
        })
        .catch((error) => {
          setSubmitting(false);
          setLoading(false);
        });
    },
  });

  return (
    <>
      <HelmetBase
        title={`${t("Forgot Password")}`}
        name={`${t("Forgot Password")}`}
      />
      <div className="container-fluid">
        <div className="row login-container">
          {/* Left Side - Image  */}
          <div className="col-md-6 left-side">
            <img
              src={forgotImage}
              alt="Login Illustration"
              className="login-image"
            />
          </div>

          {/* Right Side - Login Form  */}
          <div className="col-md-6 right-side">
            <div className="login-form">
              <div className="brand-logo d-flex justify-content-center mb-5">
                <Link to="/">
                  <img src={systemConfiguration?.logo} alt="" />
                </Link>
              </div>
              <div className="head-contant">
                <div className="head-image">
                  <img src={lockImage} alt="" />
                </div>
                <div className="head-text">
                  <h1>{t("Forgot Your Password")}?</h1>
                  <p>
                    {t(
                      "Enter the email address associated with your account and well send you a link to reset your password"
                    )}
                  </p>
                </div>
              </div>
              <Form onSubmit={formik.handleSubmit}>
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    id="email"
                    placeholder={t("Email or mobile phone number")}
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                  />
                  {formik.touched.email && formik.errors.email && (
                    <div className="text-danger">{formik.errors.email}</div>
                  )}
                </div>

                <button
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={loading ? true : false}
                >
                  {!loading ? t("Send OTP") : t("Loading...")}
                </button>
                <button
                  type="submit"
                  className="btn btn-primary w-100 mt-2"
                  style={{backgroundColor:"#082b40"}}
                  onClick={() => navigate(-1)}
                >
                  {t("Back")}
                </button>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
